export type SeasonName = 'Spring' | 'Summer' | 'Autumn' | 'Winter';

export interface CountrySeasonData {
  code: string; // ISO 3166-1 alpha-2
  name: string; // Common name for display
  emoji: string;
  hemisphere: 'N' | 'S' | 'E'; // N: Northern, S: Southern, E: Equatorial/Both
  seasonStartMonths: {
    Spring: number;
    Summer: number;
    Autumn: number;
    Winter: number;
  };
}

const NH_SEASONS = { Spring: 3, Summer: 6, Autumn: 9, Winter: 12 };
const SH_SEASONS = { Spring: 9, Summer: 12, Autumn: 3, Winter: 6 };

export const COUNTRIES_DATA: CountrySeasonData[] = [
  {
    code: 'US',
    name: 'United States',
    emoji: '🇺🇸',
    hemisphere: 'N',
    seasonStartMonths: NH_SEASONS,
  },
  { code: 'CA', name: 'Canada', emoji: '🇨🇦', hemisphere: 'N', seasonStartMonths: NH_SEASONS },
  { code: 'MX', name: 'Mexico', emoji: '🇲🇽', hemisphere: 'N', seasonStartMonths: NH_SEASONS },
  {
    code: 'GB',
    name: 'United Kingdom',
    emoji: '🇬🇧',
    hemisphere: 'N',
    seasonStartMonths: NH_SEASONS,
  },
  { code: 'DE', name: 'Germany', emoji: '🇩🇪', hemisphere: 'N', seasonStartMonths: NH_SEASONS },
  { code: 'FR', name: 'France', emoji: '🇫🇷', hemisphere: 'N', seasonStartMonths: NH_SEASONS },
  { code: 'ES', name: 'Spain', emoji: '🇪🇸', hemisphere: 'N', seasonStartMonths: NH_SEASONS },
  { code: 'IT', name: 'Italy', emoji: '🇮🇹', hemisphere: 'N', seasonStartMonths: NH_SEASONS },
  { code: 'PL', name: 'Poland', emoji: '🇵🇱', hemisphere: 'N', seasonStartMonths: NH_SEASONS },
  { code: 'UA', name: 'Ukraine', emoji: '🇺🇦', hemisphere: 'N', seasonStartMonths: NH_SEASONS },
  { code: 'RO', name: 'Romania', emoji: '🇷🇴', hemisphere: 'N', seasonStartMonths: NH_SEASONS },
  { code: 'NL', name: 'Netherlands', emoji: '🇳🇱', hemisphere: 'N', seasonStartMonths: NH_SEASONS },
  { code: 'BE', name: 'Belgium', emoji: '🇧🇪', hemisphere: 'N', seasonStartMonths: NH_SEASONS },
  { code: 'GR', name: 'Greece', emoji: '🇬🇷', hemisphere: 'N', seasonStartMonths: NH_SEASONS },
  { code: 'PT', name: 'Portugal', emoji: '🇵🇹', hemisphere: 'N', seasonStartMonths: NH_SEASONS },
  { code: 'SE', name: 'Sweden', emoji: '🇸🇪', hemisphere: 'N', seasonStartMonths: NH_SEASONS },
  { code: 'HU', name: 'Hungary', emoji: '🇭🇺', hemisphere: 'N', seasonStartMonths: NH_SEASONS },
  { code: 'BY', name: 'Belarus', emoji: '🇧🇾', hemisphere: 'N', seasonStartMonths: NH_SEASONS },
  { code: 'AT', name: 'Austria', emoji: '🇦🇹', hemisphere: 'N', seasonStartMonths: NH_SEASONS },
  { code: 'CH', name: 'Switzerland', emoji: '🇨🇭', hemisphere: 'N', seasonStartMonths: NH_SEASONS },
  { code: 'BG', name: 'Bulgaria', emoji: '🇧🇬', hemisphere: 'N', seasonStartMonths: NH_SEASONS },
  { code: 'DK', name: 'Denmark', emoji: '🇩🇰', hemisphere: 'N', seasonStartMonths: NH_SEASONS },
  { code: 'FI', name: 'Finland', emoji: '🇫🇮', hemisphere: 'N', seasonStartMonths: NH_SEASONS },
  { code: 'NO', name: 'Norway', emoji: '🇳🇴', hemisphere: 'N', seasonStartMonths: NH_SEASONS },
  { code: 'IE', name: 'Ireland', emoji: '🇮🇪', hemisphere: 'N', seasonStartMonths: NH_SEASONS },
  { code: 'HR', name: 'Croatia', emoji: '🇭🇷', hemisphere: 'N', seasonStartMonths: NH_SEASONS },
  { code: 'CN', name: 'China', emoji: '🇨🇳', hemisphere: 'N', seasonStartMonths: NH_SEASONS },
  { code: 'IN', name: 'India', emoji: '🇮🇳', hemisphere: 'N', seasonStartMonths: NH_SEASONS }, // Vast country, N.H. dominant for seasons
  { code: 'JP', name: 'Japan', emoji: '🇯🇵', hemisphere: 'N', seasonStartMonths: NH_SEASONS },
  { code: 'TR', name: 'Turkey', emoji: '🇹🇷', hemisphere: 'N', seasonStartMonths: NH_SEASONS }, // Partly in Europe
  { code: 'IR', name: 'Iran', emoji: '🇮🇷', hemisphere: 'N', seasonStartMonths: NH_SEASONS },
  { code: 'TH', name: 'Thailand', emoji: '🇹🇭', hemisphere: 'N', seasonStartMonths: NH_SEASONS }, // Tropical, but assigning N.H. pattern
  { code: 'KR', name: 'South Korea', emoji: '🇰🇷', hemisphere: 'N', seasonStartMonths: NH_SEASONS },
  { code: 'SA', name: 'Saudi Arabia', emoji: '🇸🇦', hemisphere: 'N', seasonStartMonths: NH_SEASONS },
  { code: 'MY', name: 'Malaysia', emoji: '🇲🇾', hemisphere: 'E', seasonStartMonths: NH_SEASONS }, // Equatorial, N.H. pattern default
  { code: 'PH', name: 'Philippines', emoji: '🇵🇭', hemisphere: 'N', seasonStartMonths: NH_SEASONS }, // Tropical, N.H. pattern default
  { code: 'VN', name: 'Vietnam', emoji: '🇻🇳', hemisphere: 'N', seasonStartMonths: NH_SEASONS }, // Tropical, N.H. pattern default
  { code: 'PK', name: 'Pakistan', emoji: '🇵🇰', hemisphere: 'N', seasonStartMonths: NH_SEASONS },
  { code: 'BR', name: 'Brazil', emoji: '🇧🇷', hemisphere: 'S', seasonStartMonths: SH_SEASONS }, // Large, predominantly S.H.
  { code: 'AR', name: 'Argentina', emoji: '🇦🇷', hemisphere: 'S', seasonStartMonths: SH_SEASONS },
  { code: 'CO', name: 'Colombia', emoji: '🇨🇴', hemisphere: 'E', seasonStartMonths: NH_SEASONS }, // Equatorial, N.H. pattern default
  { code: 'PE', name: 'Peru', emoji: '🇵🇪', hemisphere: 'S', seasonStartMonths: SH_SEASONS }, // Partly equatorial, S.H. dominant
  { code: 'CL', name: 'Chile', emoji: '🇨🇱', hemisphere: 'S', seasonStartMonths: SH_SEASONS },
  { code: 'EC', name: 'Ecuador', emoji: '🇪🇨', hemisphere: 'E', seasonStartMonths: NH_SEASONS }, // Equatorial, N.H. pattern default
  { code: 'VE', name: 'Venezuela', emoji: '🇻🇪', hemisphere: 'N', seasonStartMonths: NH_SEASONS },
  { code: 'NG', name: 'Nigeria', emoji: '🇳🇬', hemisphere: 'N', seasonStartMonths: NH_SEASONS }, // Equatorial influence, N.H. pattern
  { code: 'EG', name: 'Egypt', emoji: '🇪🇬', hemisphere: 'N', seasonStartMonths: NH_SEASONS },
  { code: 'ZA', name: 'South Africa', emoji: '🇿🇦', hemisphere: 'S', seasonStartMonths: SH_SEASONS },
  { code: 'DZ', name: 'Algeria', emoji: '🇩🇿', hemisphere: 'N', seasonStartMonths: NH_SEASONS },
  { code: 'SD', name: 'Sudan', emoji: '🇸🇩', hemisphere: 'N', seasonStartMonths: NH_SEASONS },
  { code: 'MA', name: 'Morocco', emoji: '🇲🇦', hemisphere: 'N', seasonStartMonths: NH_SEASONS },
  { code: 'KE', name: 'Kenya', emoji: '🇰🇪', hemisphere: 'E', seasonStartMonths: NH_SEASONS }, // Equatorial, N.H. pattern default
  { code: 'ET', name: 'Ethiopia', emoji: '🇪🇹', hemisphere: 'N', seasonStartMonths: NH_SEASONS }, // Equatorial influence, N.H. pattern
  { code: 'TZ', name: 'Tanzania', emoji: '🇹🇿', hemisphere: 'S', seasonStartMonths: SH_SEASONS }, // South of Equator
  { code: 'AU', name: 'Australia', emoji: '🇦🇺', hemisphere: 'S', seasonStartMonths: SH_SEASONS },
  { code: 'NZ', name: 'New Zealand', emoji: '🇳🇿', hemisphere: 'S', seasonStartMonths: SH_SEASONS },
  {
    code: 'PG',
    name: 'Papua New Guinea',
    emoji: '🇵🇬',
    hemisphere: 'S',
    seasonStartMonths: SH_SEASONS,
  }, // Equatorial, but S.H. pattern
  { code: 'FJ', name: 'Fiji', emoji: '🇫🇯', hemisphere: 'S', seasonStartMonths: SH_SEASONS },
  { code: 'ID', name: 'Indonesia', emoji: '🇮🇩', hemisphere: 'E', seasonStartMonths: NH_SEASONS }, // Straddles equator, N.H. default
  { code: 'AF', name: 'Afghanistan', emoji: '🇦🇫', hemisphere: 'N', seasonStartMonths: NH_SEASONS },
  { code: 'BD', name: 'Bangladesh', emoji: '🇧🇩', hemisphere: 'N', seasonStartMonths: NH_SEASONS },
  { code: 'MM', name: 'Myanmar', emoji: '🇲🇲', hemisphere: 'N', seasonStartMonths: NH_SEASONS },
  { code: 'IQ', name: 'Iraq', emoji: '🇮🇶', hemisphere: 'N', seasonStartMonths: NH_SEASONS },
  { code: 'UZ', name: 'Uzbekistan', emoji: '🇺��', hemisphere: 'N', seasonStartMonths: NH_SEASONS },
  { code: 'GH', name: 'Ghana', emoji: '🇬🇭', hemisphere: 'N', seasonStartMonths: NH_SEASONS }, // Near equator, N.H. pattern
  { code: 'CI', name: 'Ivory Coast', emoji: '🇨🇮', hemisphere: 'N', seasonStartMonths: NH_SEASONS }, // Near equator, N.H. pattern
  { code: 'CM', name: 'Cameroon', emoji: '🇨🇲', hemisphere: 'N', seasonStartMonths: NH_SEASONS }, // Near equator, N.H. pattern
  { code: 'NP', name: 'Nepal', emoji: '🇳🇵', hemisphere: 'N', seasonStartMonths: NH_SEASONS },
  { code: 'LK', name: 'Sri Lanka', emoji: '🇱🇰', hemisphere: 'N', seasonStartMonths: NH_SEASONS }, // Tropical, N.H. default
  { code: 'KZ', name: 'Kazakhstan', emoji: '🇰🇿', hemisphere: 'N', seasonStartMonths: NH_SEASONS },
  { code: 'SY', name: 'Syria', emoji: '🇸🇾', hemisphere: 'N', seasonStartMonths: NH_SEASONS },
  { code: 'KH', name: 'Cambodia', emoji: '🇰🇭', hemisphere: 'N', seasonStartMonths: NH_SEASONS },
  { code: 'JO', name: 'Jordan', emoji: '🇯🇴', hemisphere: 'N', seasonStartMonths: NH_SEASONS },
  { code: 'AZ', name: 'Azerbaijan', emoji: '🇦🇿', hemisphere: 'N', seasonStartMonths: NH_SEASONS },
  {
    code: 'AE',
    name: 'United Arab Emirates',
    emoji: '🇦🇪',
    hemisphere: 'N',
    seasonStartMonths: NH_SEASONS,
  },
  { code: 'IL', name: 'Israel', emoji: '🇮🇱', hemisphere: 'N', seasonStartMonths: NH_SEASONS },
  { code: 'TW', name: 'Taiwan', emoji: '🇹🇼', hemisphere: 'N', seasonStartMonths: NH_SEASONS },
  { code: 'SG', name: 'Singapore', emoji: '🇸🇬', hemisphere: 'E', seasonStartMonths: NH_SEASONS }, // Equatorial, N.H. default
];

export const getCountrySeasonData = (countryCode: string): CountrySeasonData | undefined => {
  return COUNTRIES_DATA.find(c => c.code === countryCode.toUpperCase());
};
